import * as React from 'react';
import styled from 'styled-components'

interface IProps
    extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    hasError?: boolean;
    type: "checkbox";
}

const CheckboxDefault: React.FC<IProps> = (props) => {

    const { children, hasError, type, ...InputProps } = props;

    return (<input {...InputProps} type={type}/>)

};

const FormCheckbox = styled(CheckboxDefault)`
`;

export default FormCheckbox;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/form/form_checkbox.tsx